import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import IconProduct from "@/components/icons/IconProduct.vue";

@Component({
  name: "Name",
  components: {
    "icon-product": IconProduct,
  },
})
class Name extends Vue {
  @Prop({ type: String, default: "" })
  readonly title!: string;

  @Prop({ type: String, default: "" })
  readonly htmlContent!: string;

  @Prop({ type: Number, default: null })
  readonly id!: number;

  @Prop({ type: Boolean, default: false })
  readonly isOnSale!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isOnDiscount!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isTop!: boolean;

  render() {
    return (
      <div class="data-name">
        <icon-base
          class="tablerow__icon"
          name="product"
          color="#f7ba00"
          style="min-width: 17px;"
        >
          <icon-product />
        </icon-base>
        <div class="tablerow__name-wrap">
          <div class="tablerow__tags">
            {this.isOnSale ? (
              <div class="data-name__tag data-name__tag--row">Распродажа</div>
            ) : null}

            {this.isOnDiscount ? (
              <div class="data-name__tag data-name__tag--discount">Акция</div>
            ) : null}
            {this.isTop ? (
              <div class="data-name__tag data-name__tag--top">ТОП</div>
            ) : null}
          </div>

          <router-link to={`/product/${this.id}`}>
            <div
              class="highlight"
              domPropsInnerHTML={this.htmlContent}
              title={this.title}
            />
          </router-link>
        </div>
      </div>
    );
  }
}

export default Name;
